(function () {
  'use strict';

  if (window.__POSWhatsAppAssistantLoaded) return;
  window.__POSWhatsAppAssistantLoaded = true;

  var STORAGE_KEY = 'pos_whatsapp_assistant_v1';
  var PRODUCT_VISITS_KEY = 'pos_whatsapp_product_visits_v1';
  var CARD_OPEN_CLASS = 'is-open';
  var VISIBLE_CLASS = 'is-visible';
  var SUPPRESSED_CLASS = 'is-suppressed';

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function toBoolean(value, fallback) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return fallback;
  }

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function readSession() {
    var fallback = {
      automaticExpansions: 0,
      manualDismissals: 0,
      lastExpandedAt: 0,
      nextEligibleAt: 0,
      clickedWhatsApp: false,
      firstShown: false
    };

    try {
      return Object.assign(fallback, safeParse(sessionStorage.getItem(STORAGE_KEY), {}));
    } catch (error) {
      return fallback;
    }
  }

  function writeSession(state) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // Storage can be unavailable in strict privacy modes. The assistant still works.
    }
  }

  function normalizePageType(rawType) {
    var type = String(rawType || '').toLowerCase();
    if (type === 'index' || type === 'home') return 'home';
    if (type.indexOf('product') !== -1) return 'product';
    if (type.indexOf('collection') !== -1 || type.indexOf('search') !== -1) return 'collection';
    if (type.indexOf('cart') !== -1) return 'cart';
    return type || 'other';
  }

  function initializeAssistant(root) {
    if (!root || root.dataset.posWaInitialized === 'true') return;
    root.dataset.posWaInitialized = 'true';

    var avatarButton = root.querySelector('[data-pos-wa-avatar]');
    var card = root.querySelector('[data-pos-wa-card]');
    var closeButton = root.querySelector('[data-pos-wa-close]');
    var laterButton = root.querySelector('[data-pos-wa-later]');
    var cta = root.querySelector('[data-pos-wa-cta]');
    var heading = root.querySelector('[data-pos-wa-heading]');
    var text = root.querySelector('[data-pos-wa-text]');

    if (!avatarButton || !card || !closeButton || !laterButton || !cta || !heading || !text) {
      root.classList.add('is-disabled');
      return;
    }

    var pageType = normalizePageType(root.dataset.pageType);
    var config = {
      number: String(root.dataset.whatsappNumber || '').replace(/\D/g, ''),
      pageType: pageType,
      pageTitle: root.dataset.pageTitle || document.title,
      productTitle: root.dataset.productTitle || '',
      variantTitle: root.dataset.variantTitle || '',
      collectionTitle: root.dataset.collectionTitle || '',
      assistantName: root.dataset.assistantName || 'Perfume Expert',
      ctaLabel: root.dataset.ctaLabel || 'Talk to Expert',
      laterLabel: root.dataset.laterLabel || 'Maybe later',
      initialDelayMs: toNumber(root.dataset.initialDelay, 7) * 1000,
      scrollTrigger: toNumber(root.dataset.scrollTrigger, 35),
      productDwellMs: toNumber(root.dataset.productDwell, 20) * 1000,
      autoCollapseMs: toNumber(root.dataset.autoCollapse, 10) * 1000,
      cooldownMs: toNumber(root.dataset.cooldown, 45) * 1000,
      maxAutomaticExpansions: toNumber(root.dataset.maxAutoExpansions, 4),
      showHome: toBoolean(root.dataset.showHome, true),
      showProduct: toBoolean(root.dataset.showProduct, true),
      showCollection: toBoolean(root.dataset.showCollection, true),
      showCart: toBoolean(root.dataset.showCartPage, true),
      messages: {
        home: {
          heading: root.dataset.homeHeading || 'Need help choosing a fragrance?',
          text: root.dataset.homeText || 'Tell us what you like and our team will help you find the right scent.'
        },
        collection: {
          heading: root.dataset.collectionHeading || 'Confused between these fragrances?',
          text: root.dataset.collectionText || 'Share your vibe, budget, or occasion and we will narrow it down for you.'
        },
        product: {
          heading: root.dataset.productHeading || 'Questions about this fragrance?',
          text: root.dataset.productText || 'Ask about longevity, projection, occasion, or the right size before you buy.'
        },
        cart: {
          heading: root.dataset.cartHeading || 'Need help before placing your order?',
          text: root.dataset.cartText || 'Our team can quickly help with offers, products, or any last-minute question.'
        }
      }
    };

    if (!config.number || !shouldShowOnPage(config)) {
      root.classList.add('is-disabled');
      return;
    }

    var state = readSession();
    var autoCollapseTimer = null;
    var reappearanceTimer = null;
    var pendingReason = '';
    var hasTriggeredInitial = state.firstShown;
    var variantChanges = 0;
    var scrollReversals = 0;
    var lastScrollY = window.scrollY || 0;
    var lastMeaningfulScrollY = lastScrollY;
    var lastDirection = 0;
    var cartOpenedAt = 0;
    var cartIndecisionTimer = null;
    var destroyed = false;

    registerProductVisit(config);
    root.classList.remove('pos-wa-assistant--unmounted');

    function shouldShowOnPage(currentConfig) {
      if (currentConfig.pageType === 'home') return currentConfig.showHome;
      if (currentConfig.pageType === 'product') return currentConfig.showProduct;
      if (currentConfig.pageType === 'collection') return currentConfig.showCollection;
      if (currentConfig.pageType === 'cart') return currentConfig.showCart;
      return false;
    }

    function isCartDrawerOpen() {
      var drawer = document.querySelector('cart-drawer');
      return Boolean(drawer && drawer.classList.contains('active'));
    }

    function isBlockingLayerOpen() {
      var body = document.body;
      var html = document.documentElement;
      if (!body || !html) return false;

      if (body.classList.contains('modal-open')) return true;
      if (body.classList.contains('pswp-open')) return true;
      if (html.classList.contains('pswp-open')) return true;
      if (isCartDrawerOpen()) return true;

      if (document.querySelector('#Details-menu-drawer-container[open]')) return true;
      if (document.querySelector('details-modal details[open]')) return true;
      if (document.querySelector('.poc-offer-modal.is-open')) return true;
      if (document.querySelector('.poc-bulk-modal.is-open')) return true;
      if (document.querySelector('.pswp.pswp--open, .pswp[aria-hidden="false"]')) return true;

      return false;
    }

    function setSuppressed(suppressed) {
      root.classList.toggle(SUPPRESSED_CLASS, suppressed);
      if (suppressed && root.classList.contains(CARD_OPEN_CLASS)) {
        clearTimeout(autoCollapseTimer);
      }
    }

    function getDefaultMessage() {
      return config.messages[config.pageType] || config.messages.home;
    }

    function getReasonMessage(reason) {
      var defaultMessage = getDefaultMessage();
      var productName = config.productTitle ? truncate(config.productTitle, 34) : '';

      if (reason === 'variant-comparison') {
        return {
          heading: 'Comparing sizes or options?',
          text: 'Tell us how you plan to use it and we will help you pick the right option.'
        };
      }

      if (reason === 'multiple-products') {
        return {
          heading: 'Comparing a few fragrances?',
          text: 'Send us the names and we will help you choose based on your taste and occasion.'
        };
      }

      if (reason === 'product-dwell' || reason === 'scroll-indecision') {
        return {
          heading: productName ? 'Still deciding on ' + productName + '?' : 'Still deciding on this fragrance?',
          text: 'Ask about its smell profile, longevity, projection, or best occasion on WhatsApp.'
        };
      }

      if (reason === 'cart-indecision') {
        return config.messages.cart;
      }

      if (reason === 'timed-return') {
        var returns = [
          {
            heading: 'Still looking for the right scent?',
            text: 'Share your budget and preferred fragrance style for a quick recommendation.'
          },
          {
            heading: 'Want a quick perfume recommendation?',
            text: 'Our team can shortlist the best options for your mood, occasion, or gift.'
          },
          {
            heading: 'Looking for something long-lasting?',
            text: 'Tell us your preferred notes and budget—we will guide you on WhatsApp.'
          }
        ];
        return returns[state.automaticExpansions % returns.length];
      }

      return defaultMessage;
    }

    function updateContent(reason) {
      var message = getReasonMessage(reason);
      heading.textContent = message.heading;
      text.textContent = message.text;
      cta.href = buildWhatsAppUrl(reason);
    }

    function buildWhatsAppUrl(reason) {
      var lines = ['Hi PerfumeOilStore Team 👋', '', getWhatsAppIntent(reason)];
      var currentVariant = readCurrentVariant();

      if (config.productTitle) {
        lines.push('', 'Product: ' + config.productTitle);
        if (currentVariant && currentVariant !== 'Default Title') {
          lines.push('Selected option: ' + currentVariant);
        }
      } else if (config.collectionTitle) {
        lines.push('', 'Collection: ' + config.collectionTitle);
      }

      if (pageType === 'cart') {
        lines.push('', 'I am currently reviewing my cart.');
      }

      lines.push('', 'Page: ' + window.location.href);
      return createWhatsAppUrl(lines.join('\n'));
    }

    function createWhatsAppUrl(message) {
      var normalizedMessage = String(message || '');

      // Normalize Unicode before URL encoding so emoji characters are preserved
      // consistently when the prefilled message is handed off to WhatsApp.
      if (typeof normalizedMessage.normalize === 'function') {
        normalizedMessage = normalizedMessage.normalize('NFC');
      }

      var encodedMessage = encodeURIComponent(normalizedMessage);
      var userAgent = navigator.userAgent || '';
      var isMobileDevice = /Android|iPhone|iPod|IEMobile|Opera Mini/i.test(userAgent);
      var isTouchIPad = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;

      if (!isMobileDevice && !isTouchIPad) {
        // On desktop, go straight to WhatsApp Web. This avoids the extra wa.me
        // desktop-app handoff where prefilled Unicode/emoji can be lost.
        return 'https://web.whatsapp.com/send?phone=' + config.number + '&text=' + encodedMessage;
      }

      return 'https://wa.me/' + config.number + '?text=' + encodedMessage;
    }

    function getWhatsAppIntent(reason) {
      if (reason === 'variant-comparison') return 'I need help choosing the right size or option.';
      if (reason === 'multiple-products') return 'I am comparing a few perfumes and need a recommendation.';
      if (reason === 'cart-indecision') return 'I need help before placing my order.';
      if (pageType === 'product') return 'I have a question about this fragrance.';
      if (pageType === 'collection') return 'Can you help me choose from these fragrances?';
      return 'Can you help me choose the right perfume?';
    }

    function getPrimaryProductRoot() {
      return (
        document.querySelector('.poc-product-root') ||
        document.querySelector('product-info[data-section]') ||
        document.querySelector('.product')
      );
    }

    function textValue(node) {
      return node ? String(node.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function getCustomVariantTitle(productRoot, variantId) {
      if (!productRoot) return '';

      var pills = productRoot.querySelectorAll('.poc-pill[data-id]');
      for (var index = 0; index < pills.length; index += 1) {
        if (!variantId || String(pills[index].dataset.id || '') === String(variantId)) {
          var pillTitle = String(pills[index].dataset.title || '').trim() || textValue(pills[index].querySelector('.poc-pill-title'));
          if (pillTitle) return pillTitle;
        }
      }

      var stickySelect = productRoot.querySelector('#StickyVariantSelect');
      if (stickySelect && stickySelect.options && stickySelect.selectedIndex >= 0) {
        var selected = stickySelect.options[stickySelect.selectedIndex];
        if (!variantId || String(selected.value) === String(variantId)) {
          var selectedTitle = textValue(selected);
          if (selectedTitle) return selectedTitle;
        }
      }

      var selectedSize = textValue(productRoot.querySelector('#PocSelectedSize'));
      if (selectedSize) return selectedSize.replace(/\s+selected\s*$/i, '').trim();
      return '';
    }

    function getDawnVariantTitle(productRoot) {
      if (!productRoot) return '';

      var selectedVariantScript = productRoot.querySelector('variant-selects script[data-selected-variant], script[data-selected-variant]');
      if (selectedVariantScript) {
        var selectedVariant = safeParse(selectedVariantScript.textContent || '', null);
        if (selectedVariant && selectedVariant.title) {
          return String(selectedVariant.title).trim();
        }
      }

      var optionValues = [];
      var selects = productRoot.querySelectorAll('variant-selects select[name^="options"], select[name^="options"]');
      for (var selectIndex = 0; selectIndex < selects.length; selectIndex += 1) {
        if (selects[selectIndex].selectedIndex >= 0) {
          var selectValue = String(selects[selectIndex].options[selects[selectIndex].selectedIndex].value || '').trim();
          if (selectValue) optionValues.push(selectValue);
        }
      }

      var checked = productRoot.querySelectorAll('variant-selects input[type="radio"]:checked');
      for (var radioIndex = 0; radioIndex < checked.length; radioIndex += 1) {
        var radioValue = String(checked[radioIndex].value || '').trim();
        if (radioValue) optionValues.push(radioValue);
      }

      return optionValues.join(' / ');
    }

    function readCurrentVariant() {
      var productRoot = getPrimaryProductRoot();
      if (!productRoot) return config.variantTitle;

      var variantInput = productRoot.querySelector('#PocVariantId, form[action*="/cart/add"] input[name="id"], input[name="id"]');
      var variantId = variantInput ? String(variantInput.value || variantInput.getAttribute('value') || '').trim() : '';

      if (productRoot.classList && productRoot.classList.contains('poc-product-root')) {
        var customTitle = getCustomVariantTitle(productRoot, variantId);
        if (customTitle && customTitle !== 'Default Title') return customTitle;
      }

      var dawnTitle = getDawnVariantTitle(productRoot);
      if (dawnTitle && dawnTitle !== 'Default Title') return dawnTitle;

      return config.variantTitle;
    }

    function truncate(value, maxLength) {
      var stringValue = String(value || '');
      if (stringValue.length <= maxLength) return stringValue;
      return stringValue.slice(0, maxLength - 1).trim() + '…';
    }

    function track(action, reason) {
      var payload = {
        event: 'pos_whatsapp_assistant',
        assistant_action: action,
        assistant_reason: reason || '',
        assistant_page_type: pageType,
        assistant_product: config.productTitle || ''
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'pos_whatsapp_assistant_' + action, {
          event_category: 'engagement',
          event_label: reason || pageType
        });
      }

      if (typeof window.clarity === 'function') {
        try {
          window.clarity('event', 'pos_wa_' + action + '_' + (reason || pageType));
        } catch (error) {
          // Clarity is optional and may not have loaded yet.
        }
      }
    }

    function canAutomaticallyExpand() {
      if (state.clickedWhatsApp) return false;
      if (state.automaticExpansions >= config.maxAutomaticExpansions) return false;
      if (Date.now() < state.nextEligibleAt) return false;
      if (document.visibilityState === 'hidden') return false;
      return true;
    }

    function requestExpand(reason, options) {
      options = options || {};
      var automatic = options.automatic !== false;

      if (destroyed) return false;
      if (root.classList.contains(CARD_OPEN_CLASS)) return false;
      if (automatic && !canAutomaticallyExpand()) return false;

      if (isBlockingLayerOpen()) {
        pendingReason = reason || 'pending';
        setSuppressed(true);
        return false;
      }

      pendingReason = '';
      setSuppressed(false);
      updateContent(reason);
      root.classList.add(VISIBLE_CLASS, CARD_OPEN_CLASS);
      avatarButton.setAttribute('aria-expanded', 'true');
      card.setAttribute('aria-hidden', 'false');

      if (automatic) {
        state.automaticExpansions += 1;
      }

      state.firstShown = true;
      state.lastExpandedAt = Date.now();
      writeSession(state);
      hasTriggeredInitial = true;
      track('expand', reason);

      clearTimeout(autoCollapseTimer);
      autoCollapseTimer = window.setTimeout(function () {
        collapse('auto-timeout', false);
      }, config.autoCollapseMs);

      return true;
    }

    function getDismissCooldown() {
      var multipliers = [1, 2, 6];
      var dismissalIndex = Math.max(0, state.manualDismissals - 1);
      var index = Math.min(dismissalIndex, multipliers.length - 1);
      return config.cooldownMs * multipliers[index];
    }

    function collapse(reason, manual) {
      if (destroyed) return;
      clearTimeout(autoCollapseTimer);
      root.classList.remove(CARD_OPEN_CLASS);
      root.classList.add(VISIBLE_CLASS);
      avatarButton.setAttribute('aria-expanded', 'false');
      card.setAttribute('aria-hidden', 'true');

      if (manual) {
        state.manualDismissals += 1;
        state.nextEligibleAt = Date.now() + getDismissCooldown();
      } else {
        state.nextEligibleAt = Math.max(state.nextEligibleAt || 0, Date.now() + config.cooldownMs);
      }

      writeSession(state);
      track(manual ? 'dismiss' : 'collapse', reason);
      scheduleTimedReturn();
    }

    function scheduleTimedReturn() {
      clearTimeout(reappearanceTimer);
      if (state.clickedWhatsApp || state.automaticExpansions >= config.maxAutomaticExpansions) return;

      var delay = Math.max(config.cooldownMs, state.nextEligibleAt - Date.now());
      reappearanceTimer = window.setTimeout(function () {
        requestExpand('timed-return', { automatic: true });
      }, delay + 250);
    }

    function revealAvatarOnly() {
      root.classList.add(VISIBLE_CLASS);
      root.classList.remove(CARD_OPEN_CLASS);
      avatarButton.setAttribute('aria-expanded', 'false');
      card.setAttribute('aria-hidden', 'true');
    }

    function handleInitialTrigger(reason) {
      if (hasTriggeredInitial) return;
      requestExpand(reason, { automatic: true });
    }

    function getScrollPercent() {
      var doc = document.documentElement;
      var scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
      return Math.min(100, Math.max(0, ((window.scrollY || doc.scrollTop || 0) / scrollable) * 100));
    }

    function handleScroll() {
      if (!hasTriggeredInitial && getScrollPercent() >= config.scrollTrigger) {
        handleInitialTrigger('scroll-depth');
      }

      if (pageType !== 'product') return;

      var currentY = window.scrollY || 0;
      var delta = currentY - lastMeaningfulScrollY;
      if (Math.abs(delta) < 150) return;

      var direction = delta > 0 ? 1 : -1;
      if (lastDirection && direction !== lastDirection) {
        scrollReversals += 1;
        if (scrollReversals >= 3) {
          requestExpand('scroll-indecision', { automatic: true });
          scrollReversals = 0;
        }
      }

      lastDirection = direction;
      lastMeaningfulScrollY = currentY;
      lastScrollY = currentY;
    }

    function handleVariantInteraction(event) {
      if (pageType !== 'product') return;
      var target = event.target;
      if (!target || !target.closest) return;

      var option = target.closest(
        '.poc-pill, ' +
        '#StickyVariantSelect, ' +
        'variant-selects select[name^="options"], ' +
        'variant-selects input[type="radio"], ' +
        'form[action*="/cart/add"] select[name="id"], ' +
        'form[action*="/cart/add"] input[type="radio"]'
      );

      if (!option) return;
      variantChanges += 1;
      if (variantChanges >= 3) {
        requestExpand('variant-comparison', { automatic: true });
        variantChanges = 0;
      }
    }

    function registerProductVisit(currentConfig) {
      if (currentConfig.pageType !== 'product' || !currentConfig.productTitle) return;

      try {
        var visits = safeParse(sessionStorage.getItem(PRODUCT_VISITS_KEY), []);
        var key = window.location.pathname;
        if (visits.indexOf(key) === -1) visits.push(key);
        visits = visits.slice(-8);
        sessionStorage.setItem(PRODUCT_VISITS_KEY, JSON.stringify(visits));

        if (visits.length >= 3) {
          window.setTimeout(function () {
            requestExpand('multiple-products', { automatic: true });
          }, 4500);
        }
      } catch (error) {
        // Ignore unavailable session storage.
      }
    }

    function isCartPopupOpen() {
      return isCartDrawerOpen();
    }

    function processOverlayState() {
      var blocked = isBlockingLayerOpen();
      setSuppressed(blocked);

      if (isCartPopupOpen()) {
        if (!cartOpenedAt) {
          cartOpenedAt = Date.now();
          clearTimeout(cartIndecisionTimer);
          cartIndecisionTimer = window.setTimeout(function () {
            pendingReason = 'cart-indecision';
          }, 14000);
        }
      } else if (cartOpenedAt) {
        var duration = Date.now() - cartOpenedAt;
        cartOpenedAt = 0;
        clearTimeout(cartIndecisionTimer);

        if (duration >= 9000 || pendingReason === 'cart-indecision') {
          pendingReason = '';
          window.setTimeout(function () {
            requestExpand('cart-indecision', { automatic: true });
          }, 600);
        }
      }

      if (!blocked && pendingReason) {
        var reason = pendingReason;
        pendingReason = '';
        window.setTimeout(function () {
          requestExpand(reason, { automatic: true });
        }, 300);
      }
    }

    function observePopupState() {
      if (typeof MutationObserver === 'undefined') return;

      var observer = new MutationObserver(processOverlayState);
      var targets = [
        document.body,
        document.documentElement,
        document.querySelector('cart-drawer'),
        document.querySelector('header-drawer'),
        document.querySelector('details-modal'),
        document.querySelector('.poc-offer-modal'),
        document.querySelector('.poc-bulk-modal')
      ];

      for (var index = 0; index < targets.length; index += 1) {
        if (!targets[index]) continue;
        observer.observe(targets[index], {
          attributes: true,
          subtree: targets[index].matches && (targets[index].matches('header-drawer') || targets[index].matches('details-modal')),
          attributeFilter: ['class', 'open', 'aria-hidden']
        });
      }

      document.addEventListener('toggle', function () {
        window.setTimeout(processOverlayState, 0);
      }, true);

      processOverlayState();
    }

    function updateBottomOffset() {
      var stickyBar = document.querySelector('#PocStickyBar');
      var bottomOffset = window.innerWidth <= 767 ? 16 : 24;

      if (stickyBar && window.innerWidth < 992) {
        var style = window.getComputedStyle(stickyBar);
        var rect = stickyBar.getBoundingClientRect();
        var isVisible =
          stickyBar.classList.contains('is-visible') &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          Number(style.opacity || 1) > 0.02 &&
          rect.height > 16 &&
          rect.bottom > 0 &&
          rect.top < window.innerHeight;

        if (isVisible) {
          bottomOffset = Math.ceil(rect.height + 10);
        }
      }

      root.style.setProperty('--pos-wa-bottom-offset', bottomOffset + 'px');
    }

    avatarButton.addEventListener('click', function () {
      if (root.classList.contains(CARD_OPEN_CLASS)) {
        collapse('avatar-toggle', false);
      } else {
        requestExpand('avatar-click', { automatic: false });
      }
    });

    closeButton.addEventListener('click', function () {
      collapse('close-button', true);
      avatarButton.focus({ preventScroll: true });
    });

    laterButton.addEventListener('click', function () {
      collapse('maybe-later', true);
      avatarButton.focus({ preventScroll: true });
    });

    cta.addEventListener('click', function () {
      cta.href = buildWhatsAppUrl('cta-click');
      state.clickedWhatsApp = true;
      state.nextEligibleAt = Number.MAX_SAFE_INTEGER;
      writeSession(state);
      clearTimeout(autoCollapseTimer);
      clearTimeout(reappearanceTimer);
      track('click', 'whatsapp');

      window.setTimeout(function () {
        collapse('whatsapp-opened', false);
      }, 150);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains(CARD_OPEN_CLASS)) {
        collapse('escape', true);
        avatarButton.focus({ preventScroll: true });
      }
    });

    document.addEventListener('click', handleVariantInteraction, true);
    document.addEventListener('change', handleVariantInteraction, true);
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateBottomOffset, { passive: true });
    window.addEventListener('orientationchange', updateBottomOffset);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && pendingReason && !isBlockingLayerOpen()) {
        var reason = pendingReason;
        pendingReason = '';
        requestExpand(reason, { automatic: true });
      }
    });

    observePopupState();
    updateBottomOffset();

    if (typeof ResizeObserver !== 'undefined') {
      var stickyBar = document.querySelector('#PocStickyBar');
      if (stickyBar) {
        new ResizeObserver(updateBottomOffset).observe(stickyBar);
      }
    }

    if (window.Shopify && window.Shopify.designMode) {
      window.setTimeout(function () {
        requestExpand('theme-editor-preview', { automatic: false });
      }, 350);
      return;
    }

    if (state.firstShown) {
      revealAvatarOnly();
      scheduleTimedReturn();
    }

    window.setTimeout(function () {
      handleInitialTrigger('time-delay');
    }, config.initialDelayMs);

    if (pageType === 'product') {
      window.setTimeout(function () {
        requestExpand('product-dwell', { automatic: true });
      }, config.productDwellMs);
    }
  }

  function boot() {
    var assistants = document.querySelectorAll('[data-pos-wa-assistant]');
    for (var index = 0; index < assistants.length; index += 1) {
      initializeAssistant(assistants[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-pos-wa-assistant]')
      : null;
    if (root) initializeAssistant(root);
  });
})();
